enum EIppPendingRegistrationUserActionType {
	FetchIppPendingRegistrationUserData = 'fetchIppPendingRegistrationUserData',
	UpdateIppPendingRegistrationUserData = 'updateIppPendingRegistrationUserData',
	ApprovePendingRegistration = 'approvePendingRegistration',
	DenyPendingRegistration = 'denyPendingRegistration'
}

export default EIppPendingRegistrationUserActionType;
